import { Component, Input, signal } from '@angular/core';

@Component({
  selector: 'app-copy-item',
  imports: [],
  templateUrl: './copy-item.component.html',
  styleUrl: './copy-item.component.css',
})
export class CopyItemComponent {

  @Input() item = '';

  isHovered = signal(false);
  isCopied = signal(false);

  onHover(state: boolean): void {
    this.isHovered.set(state);
    if (!state) {
      this.isCopied.set(false);
    }
  }

  copyToClipboard(link: string | undefined): void {
    if (link) {
      navigator.clipboard.writeText(link).then(() => {
        this.isCopied.set(true);
      }).catch(err => {
      });
    }
  }


}
